import { useCallback } from 'react';
import { useBrandsOperations } from 'entities/brands';
import {
  useOperations,
  useStations,
  useAllStations
} from 'store/features/stations';
import { useGetStationsByBrandCode } from 'store/features/stations/selectors/allStations';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { IStation } from 'dataSources/Typicode/stations/types/station';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { EMPTY_ARRAY } from 'common/constants';

export const useAddFavouriteBrand = () => {
  const stations = useStations() || EMPTY_ARRAY;
  const allStations = useAllStations() || EMPTY_ARRAY;
  const getStationsByBrandCode = useGetStationsByBrandCode();
  const { updateStations, updateAllStations } = useOperations();
  const {
    addFavouriteBrands,
    getFavouriteBrands
  } = useBrandsOperations();

  const changeStations = useCallback((brandStations: IStation[], stations?: IStation[]) => {
    if (!brandStations || !stations || !stations.length) {
      return stations || EMPTY_ARRAY;
    }

    return brandStations.reduce((acc, brandStation) => {
        const index = acc.findIndex(item => item.code === brandStation.code);
        if (index !== undefined) {
          acc[index] = { ...acc[index], favourite: true };
        }
        return acc;
    }, [...stations]);
  }, []);

  const addFavouriteBrand = useCallback(async (billingId: string, brandCode: string) => {
    await addFavouriteBrands([Number(billingId)]);
    getFavouriteBrands();
    const brandStations = getStationsByBrandCode(brandCode);
    updateStations(changeStations(brandStations, stations));
    updateAllStations(changeStations(brandStations, allStations));
    logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.addFavouriteBrand, { extra: { brandCode } });
  }, [
    addFavouriteBrands,
    getFavouriteBrands,
    getStationsByBrandCode,
    changeStations,
    updateStations,
    stations,
    allStations,
    updateAllStations
  ]);

  return addFavouriteBrand;
};
